<template>
  <div class="addVoucher">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22">
          <el-form-item label="选择商品类型" prop="serviceType">
            <el-radio-group v-model="form.serviceType" class="templateCards">
              <div v-if="!retailSe && !adFictite">
              <el-radio :label="1" :disabled="disable1">
                <b>单次服务商品</b>
                <p>如：{{seviSingle}}</p>
              </el-radio>
              <el-radio :label="2" :disabled="disable2">
                <b>整套服务商品</b>
                <p>如：{{seviComplete}}</p>
              </el-radio>
              </div>
              <el-radio :label="10" v-if="retailSe">
                <b>零售商品</b>
                <p>如：{{seviRetail}}</p>
              </el-radio>
              <el-radio :label="11" v-if="adFictite">
                <b>虚拟商品</b>
                <p>如：{{seviFictitious}}</p>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="虚拟商品名称" prop="serviceName" v-if="form.serviceType == 11">
            <el-input v-model="form.serviceName" placeholder="请输入虚拟商品名称" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="单次服务商品名称" prop="serviceName" v-if="form.serviceType == 1">
            <el-input v-model="form.serviceName" placeholder="请输入单次服务商品名称" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="整套服务商品名称" prop="serviceName" v-if="form.serviceType == 2">
            <el-input v-model="form.serviceName" placeholder="请输入整套服务商品名称" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="零售商品名称" prop="serviceName" v-if="form.serviceType == 10">
            <el-input v-model="form.serviceName" placeholder="请输入零售商品名称" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="选择对应整套服务商品" required label-width="190px" v-if="form.serviceType == 1">
            <template>
              <el-button class="darkBtn" style="width:155px" @click="chooseRelation">关联整套服务商品</el-button>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.serviceType == 1 && seversRow && seversRow != ''">
          <el-col :span="12" style="margin-left: 28%;">
            <div class="serviceRow">
              <b>商品名称</b>
              <p>{{seversRow.serviceName}}</p>
            </div>
          </el-col>
        </el-col>
        </el-row>
        <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务次数" prop="serviceTime" v-if="form.serviceType != 10 && form.serviceType != 11">
            <el-input style="width:135px" v-model="form.serviceTime" placeholder="请输入服务次数" :disabled="form.serviceType == 1"></el-input>
          </el-form-item>
          <el-form-item label="售价" prop="price">
            <el-input v-model="form.price" placeholder="请输入售价" style="width:135px"></el-input> 元
          </el-form-item>
          <el-form-item label="简介" prop="remarks">
            <el-input type="textarea" v-model="form.remarks" style="height:96px;" placeholder="请输入简介,30字以内" resize="none"></el-input>
          </el-form-item>
          <el-form-item label="当前单次服务库存" :label="form.serviceType == 1?'当前单次服务库存':(form.serviceType == 2?'当前整套服务库存':'当前商品库存')" prop="availableStock" v-if="form.serviceType != 11">
            <el-input v-model="form.availableStock" style="width:135px"></el-input> {{form.serviceType == 1?'次':(form.serviceType == 2?'套':'件')}}
          </el-form-item>
          <el-form-item label="是否计入提成" prop="isFee" required>
            <el-select v-model="form.isFee" style="width:120px">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22">
          <el-form-item label="商品展示图" prop="files">
            <el-upload class="uploadLists" :action="uploadUrl" list-type="picture-card" :file-list="fileListData" multiple :limit="6" accept=".jpg, .png, .jpeg, .gif" :before-upload="beforeAvatarUpload" :before-remove="beforeRemove" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-exceed="handleExceed" :on-error="uploadError" :on-success="uploadSuccess" :on-change="addFile">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="fileImg" alt>
            </el-dialog>
            <div class="picNum">
              <b>{{fileLength}}</b>/6
            </div>
            <div class="require">
              <b>图片要求：</b>
              <p>1. 请上传横版4：3比例的清晰图片，例如尺寸：1200*900px</p>
              <p>2. 请上传至少一张图片，最多可上传六张图片</p>
              <p>3. 照片要求格式为JPG/JPEG/GIF/PNG，大小不要超过2M</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div class="seize"></div>
        </el-col>
        <el-col :span="22">
          <div class="btnOptions">
            <el-button class="darkBtn" @click="closeTab">取消</el-button>
            <el-button class="redBtn" @click="onlySave()">保存</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog title="选择关联服务项目" :visible.sync="dialogTableVisible" :center="true" width="760px">
      <severRelation @rowClicks="rowClickMethod" />
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import severRelation from "./severRelation";
import {insertServiceBase,uploadUrl,deleteFiles, viewServiceBase,updateServiceBase} from "@/api";
export default {
  components: {
    severRelation
  },
  data() {
    const isvalidateNumber = (rule, value, callback) => {// 数字,最大10000
      if (value != null && value != "") {
        if (/^[1-9]\d*$/.test(value) == false) {
          callback(new Error("请输入正整数"));
        } else if (Number(value) > 10000) {
          callback(new Error("最大为10000"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isvalidateMoney = (rule, value, callback) => {  // 价格
      if(Number(value)){
        if (!Number.isInteger(Number(value)) && value.toString().split('.')[1].length > 2) {
          callback(new Error("不能超过两位小数"));
        } else if(Number(value) > 99999.99){
          callback(new Error("金额最大99999.99"));
        } else if(Number(value) < 0){
          callback(new Error("金额不能为负"));
        } else{
          callback();
        }
      }else if(Number(value) === 0){
        callback();
      }else{
        callback(new Error("金额只能是数字，且保留两位小数"));
      }
    };
    const validatePic = (rule, value, callback) => {// 商品展示图
      setTimeout(() => {
        if (this.fileLength == 0) {
          callback(new Error("请上传至少一张图片"));
        } else {
          callback();
        }
      }, 200);
    };
    return {
      form: {
        serviceType: 1, //默认不选中，1是单次服务2是整套服务
        serviceName: "",
        serviceTime:1,
        isFee:1,
        availableStock:0,
        remarks:'',
        files:[]
      },
      uploadUrl,
      uploadFileUrl: "",
      fileImg: "",
      fileLength: 0,
      fileListData:[],
      dialogVisible:false,
      seversRow:'',
      rules: {
        // availableStock:[
        //   {required: true, message: "请输入库存", trigger: "blur" },
        //   {validator: isvalidateNumber,trigger: "blur"}
        // ],
        serviceTime:[
          { required: true, message: "请输入服务次数", trigger: "blur" },
          {validator: isvalidateNumber,trigger: "blur"}
        ],
        serviceType: [
          { required: true, message: "请选择体验券模板", trigger: "change" }
        ],
        serviceName: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {min: 1,max: 20,message: "长度在 1 到 20 个字符",trigger: "blur"}
        ],
        price: [
          {required: true,message: "请输入售价",trigger: "blur"},
          { type: "number", validator: isvalidateMoney }
        ],
        remarks: [
          {required: true,message: "请输入简介",trigger: "blur"},
          {min: 1,max: 30, message: "长度在 1 到 30 个字符",trigger: "blur"}
        ],
        // files: [{ required: true, validator: validatePic }]
      },
      dialogTableVisible: false, //选择套盒弹框
      retailSe:false,
      adFictite:false,
      disable1:false,
      disable2:false,
      seviSingle:'',
      seviComplete:'',
      seviRetail:'',
      seviFictitious:'',
      deleteFilesImg:[]
    };
  },
  watch: {
    $route: "viewServi"
  },
  created() {
    if(this.$store.state.userInfo.brandId == 1){
      this.seviSingle = '单次减肥塑形'
      this.seviComplete = '瘦腰减腹、舒经活络'
      this.seviRetail = '婷美摩力21塑形内衣'
      this.seviFictitious = '开奶、回乳'
    }else if(this.$store.state.userInfo.brandId == 2){
      this.seviSingle = '儿童消食单次'
      this.seviComplete = '儿童消食整套'
      this.seviRetail = '消食保健贴'
      this.seviFictitious = '小儿推拿'
    }else{
      this.seviSingle = '催乳、药浴、开奶类体验券'
      this.seviComplete = '催乳、药浴、开奶类体验券'
      this.seviRetail = '催乳、药浴、开奶类体验券'
      this.seviFictitious = '催乳、药浴、开奶类体验券'
    }
    this.viewServi();
    if(this.$route.path.split('/')[2] == 'retailService' || this.$route.meta.edit == 'retailEdit'){
      this.retailSe = true;
      this.adFictite = false;
      this.form.serviceType = 10;
    }else if(this.$route.params.type == 11 || this.$route.meta.edit == 'editFictite'){
      this.retailSe = false;
      this.adFictite = true;
      this.form.serviceType = 11;
    }else{
      this.retailSe = false;
      this.adFictite = false;
      this.form.serviceType = Number(this.$route.params.type);
    }
  },
  methods: {
    viewServi(){
      if(this.$route.params.id){
        viewServiceBase({
          id:this.$route.params.id,
          serviceType:this.form.serviceType
        }).then(res => {
          if(res.code == 1){
            let fileImgs = [];
            this.form = res.data;
            this.seversRow = {
              id:res.data.completeServiceId,
              serviceName:res.data.completeServiceName
            };
            for (let i of res.data.files) {
              fileImgs.push({
                id: i.id,
                url: i.file,
                name: i.fileName
              });
            }
            this.fileListData = fileImgs;
            this.fileLength = this.fileListData.length;
            if(this.form.serviceType == 1){
              this.disable1=false
              this.disable2=true
            }else if(this.form.serviceType == 2){
              this.disable1=true
              this.disable2=false
            };
          }
        });
      }else{
        this.form = Object.assign({}, this.$options.data().form);
        this.form.serviceType = Number(this.$route.params.type)
        this.fileListData = [];
        this.fileLength = 0;
        this.seversRow = '';
        this.disable1=false
        this.disable2=false
      }
    },
    onlySave() {      // 保存
      this.$refs.form.validate(valid => {
        if (valid) {
          for(let m of this.deleteFilesImg){
            deleteFiles({
              id: m.id
            });
          };
          if(!this.$route.params.id){
            if(this.form.serviceType == 1 && !this.seversRow.id){
              this.$message({
                message:'请选择关联整套服务商品',
                type:"warning"
              })
            }else{
              let postData={
                completeServiceId:this.seversRow.id,
                completeServiceName:this.seversRow.serviceName,
                brandId:this.$store.state.userInfo.brandId,
                creatorId:this.$store.state.userInfo.staffId,
                createName:this.$store.state.userInfo.staffName,
                storeCode:this.$store.state.userInfo.storeCode,
              }
              postData = Object.assign(postData,this.form);
              insertServiceBase(postData).then(res => {
                if(res.code == 1){
                  this.$message({
                    message:res.msg,
                    type:'success'
                  });
                  this.closeTab();
                }else{
                  this.$message({
                    message:res.msg,
                    type:'warning'
                  });
                }
              });
            }
          }else{
            this.form.creatorId = this.$store.state.userInfo.staffId;
            this.form.createName = this.$store.state.userInfo.staffName;
            this.form.completeServiceId = this.seversRow.id;
            this.form.completeServiceName = this.seversRow.serviceName;            
            updateServiceBase(this.form).then(res => {
              if(res.code == 1){
                this.$message({
                  message:res.msg,
                  type:'success'
                });
                this.closeTab();
              }else{
                this.$message({
                  message:res.msg,
                  type:'warning'
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    chooseRelation() {// 选择套盒
      this.dialogTableVisible = true;
    },
    rowClickMethod(val) {// 选择关联商品后的回调
      this.seversRow = val;
      this.dialogTableVisible = false;
    },
    closeTab() { // 取消
      if(this.$route.path.split('/')[2] != 'addService'){
        this.$store.commit("delete_tabs", this.$route.path)
      }
      this.$store.commit("setAliveStatus", true);//保留列表页状态
      if(this.$route.path.split('/')[2] == 'retailService' || this.$route.meta.edit == 'retailEdit'){
        this.$router.push('/businessManagementCenter/retailgoods');
      }else if(this.$route.params.type == 11 || this.$route.meta.edit == 'editFictite'){
        this.$router.push('/businessManagementCenter/fictitious');
      }else{
        this.$router.push('/businessManagementCenter/service');
      }

    },
    handleRemove(file, fileList) {
      const extension = (file.name.split(".")[1] || file.url.split(".").slice(-1)[0]) === "jpg";
      const extension1 = (file.name.split(".")[1] || file.url.split(".").slice(-1)[0]) === "png";
      const extension2 = (file.name.split(".")[1] || file.url.split(".").slice(-1)[0]) === "jpeg";
      const extension3 = (file.name.split(".")[1] || file.url.split(".").slice(-1)[0]) === "gif";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension1 && !extension2 && !extension3) {
        return;
      } else {
        //   删除图片
        if (file.id) {
          this.deleteFilesImg.push({ id:file.id });
        }
        this.fileLength = fileList.length;
        this.form.files.forEach((i, index) => {
          if (i.file == file.url) {
            this.form.files.splice(index, 1);
          }
        });
      }
    },
    handlePictureCardPreview(file) {
      this.fileImg = file.url;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 6 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension1 && !extension2 && !extension3 || !isLt2M) {
        return;
      } else {
        if (file) {
          return this.$confirm(`确定移除 ${file.name}？`);
        } else {
          let imgNames = file.response.data.files[0].name;
          return this.$confirm(`确定移除 ${imgNames}？`);
        }
      }
    },
    uploadSuccess(response, file, fileList) {
      // 上传成功后的回调
      //   this.fileUrl.push(response.obj[0]);
      this.form.files.push({
        file: response.files[0].url,
        fileName: response.files[0].name
      });
    },
    uploadError(response, file, fileList) {
      // 上传错误
      this.$message({
        message: "上传失败，请重试！",
        type: "error"
      });
    },
    addFile(file, fileList) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (
        (!extension && !extension1 && !extension2 && !extension3) ||
        !isLt2M
      ) {
        return;
      } else {
        this.fileLength = fileList.length;
      }
    },
    beforeAvatarUpload(file) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension1 && !extension2 && !extension3) {
        this.$message({
          message: "上传模板只能是 .jpg,.png,.jpeg,.gif 格式!",
          type: "error"
        });
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2M!");
      }
      return (extension || extension1 || extension2 || extension3) && isLt2M;
    },
  }
};
</script>
<style lang="less" scoped>
.serviceRow{width: 100%;border:1px solid #ccc; margin:3% auto 6%;}
.serviceRow b{display:block;width: 100%;height:40px; text-align:center;font-size: 15px;line-height:40px; background: #f5f8fa;}
.serviceRow p{width: 100%;font-size: 16px;text-align:center;margin:10px 0;}
.addVoucher {
  width: 950px;
  overflow: hidden;
  margin: 0 auto;
  padding: 80px 0 60px;
  position: relative;
  .uploadLists {
    display: inline-block;
  }
  .picNum {
    width: 72px;
    height: 28px;
    border: 1px solid #dee6ea;
    border-radius: 14px;
    margin: 15px 0 20px;
    text-align: center;
    line-height: 28px;
  }
  .require {
    line-height: 27px;
    color: #666;
  }
  .seize {
    height: 20px;
  }
  .tips {
    color: #9fa3ad;
    margin-left: 10px;
  }
  .el-form-item {
    margin-bottom: 22px;
  }
  .btnOptions {
    margin: 50px 0 0 150px;
    .onSale {
      background: #2ecfa7;
      color: #fff;
    }
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
  .templateCards {
    //   单项多项卡片
    .el-radio {
      width: 240px;
      height: 126px;
      text-align: center;
      margin-right: 38px;
      border-radius: 12px;
      background: #e9ecf4;
      position: relative;
      &.is-checked {
        background: #ffb7c1;
        b {
          color: #fff;
        }
        p {
          background: #ff95a4;
        }
      }
      b {
        color: #abb1c3;
        font-size: 26px;
        line-height: 80px;
      }
      p {
        width: 100%;
        height: 46px;
        line-height: 46px;
        color: #fff;
        background: #abb1c3;
        position: absolute;
        z-index: 99;
        bottom: 0;
        left: 0;
        border-radius: 0 0 12px 12px;
      }
    }
  }
}
</style>
<style lang="less">
.addVoucher {
  .el-table td,
  .el-table th {
    padding: 0;
  }
  .el-date-editor .el-range-separator {
    padding: 0;
    width: auto;
  }
  .layui-layedit {
    border-radius: 14px;
  }
  .el-input-number .el-input__inner{
    border-radius: 4px;
  }
  .templateCards {
    .el-radio__input {
      position: absolute;
      bottom: -2px;
      right: 0;
      z-index: 999;
      &.is-checked {
        .el-radio__inner {
          background: url(../../assets/images/store/btn_select3.png) no-repeat
            center;
        }
      }
      .el-radio__original {
        width: 100%;
        height: 100%;
      }
      .el-radio__inner {
        width: 46px;
        height: 40px;
        border-radius: 0;
        background: none;
        border: none;
      }
    }
  }
  .tableGoods {
    .myTitle {
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/addService.vue